
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes02Off as ObiDiodes02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-02-off.js';
 
 
 

 
 export const ObiDiodes02Off = createComponent({
   react: React,
   tagName: 'obi-diodes-02-off',
   elementClass: ObiDiodes02OffElement,
   events: {
     
   }
  });
 
 